import { redirect } from 'react-router-dom'
import { getSubscriptions, SubscriptionInfo } from '../helpers/revenueCat'
import { getUser } from '../helpers/supabase'

export interface GetSubscriptionsLoaderData {
  subscriptions: SubscriptionInfo[]
  cancelableSubscriptions: SubscriptionInfo[]
  refundableSubscriptions: SubscriptionInfo[]
  userEmail: string
}

export default async function getSubscriptionsLoader(): Promise<
  GetSubscriptionsLoaderData | Response
> {
  const {
    data: { user },
  } = await getUser()

  if (!user) {
    let url = '/account/sign-in'

    if (location.pathname) {
      url += `?path=${location.pathname}`
    }

    return redirect(url)
  }

  const allSubscriptions = await getSubscriptions(user.id)

  const activeSubscriptions = allSubscriptions.filter(
    (subscription) => subscription.isActive,
  )

  const refundableSubscriptions = activeSubscriptions.filter((subscription) => {
    const purchaseDate = subscription.purchaseDate
    const daysSincePurchase =
      (Date.now() - purchaseDate.getTime()) / (1000 * 60 * 60 * 24)

    return daysSincePurchase <= 14 // Only subscriptions less than 14 days old are refundable
  })

  return {
    subscriptions: allSubscriptions,
    cancelableSubscriptions: activeSubscriptions,
    refundableSubscriptions,
    userEmail: user.user_metadata.original_email!,
  }
}
